/**
 * 深拷贝、浅拷贝
 */

/**
 * 深拷贝、浅拷贝
 * @param target 被拷贝值
 * @param isDeep 是否深拷贝，默认false
 * @param weakMap 不需要传
 */
export default function clone<T = any>(
  target: any,
  isDeep = false,
  weakMap = new WeakMap(),
): T {
  const typeofTarget = typeof target;
  // null、非object直接返回
  if (typeofTarget !== 'object' || target === null) return target;

  const obj: any = Array.isArray(target) ? [] : {};
  // 处理对象的循环依赖
  if (weakMap.has(target)) {
    return weakMap.get(target);
  }
  weakMap.set(target, obj);

  for (const key in target) {
    obj[key] = isDeep ? clone(target[key], isDeep, weakMap) : target[key];
  }
  return obj;
}
